<div class="min-h-screen bg-black">
    <div class="flex justify-center">
        <div class="container">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
